import { Loader } from '@getro/rombo';
import { Download } from 'lucide-react';
import React from 'react';
import { Flex } from 'rebass/styled-components';
import PropTypes from 'prop-types';

import ActionsIcon from './actionsIcon';
import { useExportContactsCsv } from '../hooks/useExportContactsCsv';

export const ActionExport = ({ queryParams, contactIds, selectedRows, meta }) => {
  const { onClickExportContacts, isLoading } = useExportContactsCsv({ selectedRows, queryParams, contactIds, meta });

  return isLoading ? (
    <Flex sx={{ alignItems: 'center', justifyContent: 'center' }} width="70px" height="100%">
      <Loader size="small" />
    </Flex>
  ) : (
    <ActionsIcon onClick={onClickExportContacts} icon={Download} text="Export" />
  );
};

ActionExport.propTypes = {
  queryParams: PropTypes.object,
  contactIds: PropTypes.array,
  meta: PropTypes.object,
  selectedRows: PropTypes.array,
};

ActionExport.defaultProps = {
  queryParams: {},
  contactIds: [],
  meta: {},
  selectedRows: [],
};
